import React, { useContext, useMemo } from "react";

import { Preview } from "@creatomate/preview";
import { Icon } from "@culturehq/components";

import { Trans } from "app/utils";
import AccessibleFocusOutlineElement from "components/common/AccessibleFocusOutlineElement";
import SubtitlesFilledIcon from "components/common/icons/SubtitlesFilledIcon";
import SubtitlesIcon from "components/common/icons/SubtitlesIcon";
import { CreatomateContext } from "../contexts/VideoStudioContext";
import { isSubtitleText } from "./tabs/subtitle/utils";

interface SubtitlesButtonProps {
  blockSubtitlesTab?: boolean;
  preview: Preview;
}

const SubtitlesButton: React.FC<SubtitlesButtonProps> = ({ blockSubtitlesTab, preview }) => {
  const { data } = useContext(CreatomateContext);
  const { activeMenuItem } = data;
  const { ready } = preview || { ready: false };
  const { elements } = preview.state || { elements: [] };
  const allSubtitleElements = useMemo(() => elements.filter(
    element => isSubtitleText(element.source.name)), [elements]
  );

  return (
    <AccessibleFocusOutlineElement tag="button" className="chq-btn" disabled={blockSubtitlesTab || !ready}>
      {activeMenuItem === "subtitles" ? <SubtitlesFilledIcon /> : <SubtitlesIcon />}
      <Trans>Subtitles</Trans>
      {allSubtitleElements.length === 0
        ? <Icon className="Required-Icon Info-Icon" icon="info" />
        : <Icon className="Completed-Icon Info-Icon" icon="ios-checkmark" />}
    </AccessibleFocusOutlineElement>
  );
};

export default SubtitlesButton;
